import React, { useState } from 'react';
import {
  Flex,
  HStack,
  IconButton,
  Modal,
  ModalOverlay,
  ModalBody,
  ModalContent,
  ModalCloseButton,
  ModalHeader,
} from '@chakra-ui/react';
import { FaGlobe } from 'react-icons/fa';
import { AiOutlineLogout } from 'react-icons/ai';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useAuth from '../../hooks/useAuth';

const idioms = [
  { code: 'en', flag: 'https://flagcdn.com/w2560/us.png' },
  { code: 'es', flag: 'https://flagcdn.com/w2560/es.png' },
  { code: 'ptBr', flag: 'https://flagcdn.com/w2560/br.png' },
];

interface Props {
  headerSize: number;
}

const Header: React.FC<Props> = ({ headerSize }) => {
  const { signOut } = useAuth();
  const history = useHistory();
  const [isOpen, setIsOpen] = useState(false);
  const { t, i18n } = useTranslation();

  const changeLanguage = (languageCode: string) => {
    i18n.changeLanguage(languageCode);
  };

  return (
    <Flex
      as="header"
      bg="white"
      align="center"
      zIndex={10}
      h={headerSize}
      p="20px"
      boxShadow="md"
    >
      <HStack spacing={2} ml="auto">
        <IconButton
          aria-label="change-language"
          alignItems="center"
          justifyContent="center"
          onClick={() => {
            setIsOpen(true);
          }}
          icon={<FaGlobe size={20} />}
          variant="outline"
          colorScheme="cyan"
        />
        <IconButton
          aria-label="add-banner"
          alignItems="center"
          justifyContent="center"
          onClick={() => {
            signOut();
            history.push('/auth');
          }}
          icon={<AiOutlineLogout size={20} />}
          variant="outline"
          colorScheme="cyan"
        />
      </HStack>
      <Modal
        onClose={() => {
          setIsOpen(false);
        }}
        isOpen={isOpen}
        isCentered
        size="5xl"
      >
        <ModalOverlay />
        <ModalContent maxH="90vh" overflowY="scroll">
          <ModalCloseButton />
          <ModalBody>
            <ModalHeader>{t('yourLanguage')}</ModalHeader>
            <Flex justifyContent="center" w="100%" gridGap={5}>
              {idioms.map(idiom => (
                <button
                  type="button"
                  onClick={() => changeLanguage(idiom.code)}
                >
                  <img
                    id={`language_${idiom.code}`}
                    style={{ margin: '10px' }}
                    key={idiom.code}
                    src={idiom.flag}
                    alt="flag"
                    width="100px"
                    height="100px"
                  />
                </button>
              ))}
            </Flex>
          </ModalBody>
        </ModalContent>
      </Modal>
    </Flex>
  );
};

export default Header;
